import axios from "axios";
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import{
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_getBuildingPhotos,
	_makeSlugifiedArr,
	_shouldShow,
	_urlToName,
	_getBuildingURL,
	_qaThreadMap,
	_formatUnitNumber,
	_formatAddressAutoComplete
} from '../../../../../shared/helpers/utils';
function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}


const filterOptions = (options, { inputValue }) => { return options }
const apiUrl = process.env.API_ROOT;  
  
const renderAddressSearch = (props) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [value, setValue] = React.useState(props.value);
  const [inputValue, setInputValue] = React.useState(null);
  const loading = open && options.length === 0;

  React.useEffect(() => {
    let active = true;

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      return undefined;
    }
// `${apiUrl}/pipeline/autocomplete?input=${inputValue}`
    axios({ method:'get', url: `${apiUrl}/pipeline/autocomplete?input=${inputValue}`   }).then((results) => {
      if (active) {
        let newOptions = [];


        if (results && results.data) {
          newOptions = [...newOptions, ...results.data];
        }
		if(inputValue && newOptions.length>0){
			newOptions = newOptions.map(option => {
				let bestAddress = _formatAddressAutoComplete(option, inputValue);
				
				if(bestAddress.building_display){
					option.display_full_street_address = bestAddress.building_display;
				}
				
				return option;
				
			});
		}
		
        setOptions(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [value, inputValue, axios]);

  React.useEffect(() => {
/*
    if (!open) {
      setOptions([]);
    }
*/
  }, [open]);

  return (
    <Autocomplete
      freeSolo
      id="asynchronous-demo"
      style={{ width: '100%' }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      filterOptions={filterOptions}
      getOptionSelected={(option, value) => option.display_full_street_address === value.display_full_street_address}
      getOptionLabel={(option) => _capitalizeText(option.display_full_street_address)}
      options={options}
      loading={false}
      value={value}
      label={inputValue}
      onChange={(event, newValue) => {
        setOptions(newValue ? [newValue, ...options] : options);
        setValue(newValue);
        props.onChange(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
        props.onChange(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={inputValue && inputValue.display_full_street_address ? _capitalizeText(inputValue.display_full_street_address) : "Project Address"}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {false ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
      renderOption={(option) => {
        return (
          <div>{_capitalizeText(option.display_full_street_address)}, {_capitalizeText(option.neighborhood[0])}, {_capitalizeText(option.borough)}</div>
        );
      }}
    />
  );
}

export default renderAddressSearch;